<div class="profile-container">
  <div class="profile-content">
    <div class="personal-details">
      <div class="header-block">
        <div class="header-title">
          <app-breadcrumb></app-breadcrumb>
        </div>
        <div class="add-block">
            <div hidden="true">
                <input type="file" #excelFileInput
 (change)="onExcelFileChange($event,excelFileInput)" id="add-btn" />
            </div>
          
          <div class="map-view-toggle" *ngIf="isExcel && !isFailedObject">
            <span class="toggle-label">MAP VIEW</span>
            <label class="switch">
              <input type="checkbox" [checked]="isMapView" (change)="toggleMapView(!isMapView)">
              <span class="slider round"></span>
            </label>
          </div>

          <!-- <button class="add-submit" title="submit">Submit</button> -->
          <button title="select excel" (click)="addAssetClick()"><i class="bi bi-upload"></i> Upload File</button>
          <!-- <button data-toggle="modal" title="Clone Asset" data-target="#cloneDeviceModal"><i class="bi bi-plus-lg"></i> Clone</button> -->

          <div class="filter-icon">
            <i class="bi bi-arrow-clockwise" (click)="refresh()" title="Refresh"></i>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12 col-md-12 table-data" *ngIf="isExcel && !isFailedObject && !isMapView">
          <table class="table table-striped">
            <thead>
              <tr>
                <th style="width: 10%;">Id</th>
                <th style="width: 20%;">Name</th>
                <th style="width: 15%;">Serial No</th>
                <th style="width: 15%;">Original Cost</th>
                <th style="width: 15%;">Current Cost</th>
                <th style="width: 15%;">Condition</th>
                <th style="width: 10%;text-align: center;padding: 0;" class="">Action</th>
              </tr>
            </thead>
          </table>
          <div *ngIf="!isLoading">
            <div class="data-view" id="{{list.id}}" *ngFor="let list of objectInfoList1 | paginate : {
                itemsPerPage: tableSize,
                currentPage: page,
                totalItems: count
              }  ;let i = index">

              <p style="width: 10%;">{{list.id}}</p>
              <p style="width: 20%;">{{list.givenName}}</p>
              <p style="width: 15%;">{{list.serialNumber || '--'}}</p>
              <p style="width: 15%;">{{list.originalCost || '--'}}</p>
              <p style="width: 15%;">{{list.currentCost || '--'}}</p>
              <p style="width: 15%;">{{list.objectCondition || '--'}}</p>
              <p class="action-buttons" style="width: 10%;padding-left: 25px;">
                <i data-toggle="modal" title="View" (click)="getObjectInfoById(list,i)" data-target="#viewModal" class="bi bi-eye-fill"></i>
                <!-- <i title="Remove" (click)="change(list)" class="bi bi-trash" data-toggle="modal" data-target="#deleteModal"></i> -->
              </p>
            </div>
          </div>


          <div class="loader" *ngIf="isLoading">
            <div class="spinner"></div>
          </div>

          <div class="loader" *ngIf="!isLoading && objectInfoList1.length == 0">
            <div class="no-data">
              <img src="assets/no-data-6.png" alt="">
              <p>no data found</p>
            </div>
          </div>

          <div class="paginator">
            <div class="add-submit" *ngIf="!isLoading && objectInfoList1.length != 0">
                <button (click)="insertMultipleObjectInfos()">Submit</button>
            </div>
            <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="count"
              [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}">
            </p-paginator>
          </div>
        </div>


        <!-- MAP VIEW FOR VALID ASSETS -->
        <div class="col-lg-12 col-md-12" *ngIf="isExcel && !isFailedObject && isMapView">
          <div class="map-content-wrapper">
            <!-- MAP -->
            <div class="map-panel" [class.map-fullscreen]="isFullscreen">
              <button class="fullscreen-btn" (click)="toggleFullscreen()"
                [title]="isFullscreen ? 'Exit Fullscreen' : 'Fullscreen'">
                <i class="bi" [ngClass]="isFullscreen ? 'bi-fullscreen-exit' : 'bi-fullscreen'"></i>
              </button>
              <div id="map"></div>
            </div>

            <!-- LIST SIDEBAR -->
            <div class="list-panel">
              <!-- List Heading -->
              <div class="list-heading">
                <h3>Asset List</h3>
                <div class="heading-actions">
                  <span class="asset-count">{{objectInfoList1.length}}</span>
                  <button class="submit-btn" (click)="insertMultipleObjectInfos()" [disabled]="isLoading">
                    <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                    {{ isLoading ? 'Submitting...' : 'Submit' }}
                  </button>
                </div>
              </div>

              <!-- Locations -->
              <div class="location-list">
                <div class="empty-state" *ngIf="objectInfoList1.length === 0">
                  <p>No Assets found</p>
                </div>

                <div class="location-card" *ngFor="let item of objectInfoList1; let i = index"
                  [class.active]="item.selected" (click)="toggleSelection(i)">
                  <div class="check-circle" [class.checked]="item.selected">
                    <i class="bi bi-check2" *ngIf="item.selected"></i>
                  </div>
                  <div class="location-info">
                    <div class="location-name">
                      {{item.givenName}}
                    </div>
                  </div>
                  <div class="asset-icons-container" *ngIf="(!item.multiLatLng && (!item.lat || !item.lng)) || (item.multiLatLng && (!item.area || item.area.length === 0))">
                    <div class="text-primary type-icon" [title]="item.multiLatLng ? 'Line location' : 'Point location'">
                      <i class="bi" [ngClass]="item.multiLatLng ? 'bi-bezier2' : 'bi-geo-alt-fill'"></i>
                    </div>
                    <div class="text-warning warning-icon" title="Location missing">
                      <i class="bi bi-exclamation-circle"></i>
                    </div>
                  </div>
                  <div class="action-icon ms-2" *ngIf="item.selected">
                    <i class="bi bi-chevron-right"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>



        <div class="col-lg-12 col-md-12 table-data"  *ngIf="isExcel && !isFailedObject">
        <div class="duplicated">
            <h5>Duplicated or Defect</h5>
        </div>
          <table class="table table-striped">
            <thead>
              <tr>
                <th style="width: 10%;">Id</th>
                <th style="width: 20%;">Name</th>
                <th style="width: 15%;">Serial No</th>
                <th style="width: 15%;">Original Cost</th>
                <th style="width: 15%;">Current Cost</th>
                <th style="width: 15%;">Condition</th>
                <th style="width: 10%;text-align: center;padding: 0;" class="">Action</th>
              </tr>
            </thead>
          </table>
          <div *ngIf="!isLoading">
            <div class="data-view" id="{{list.id}}" *ngFor="let list of objectInfoList2 | paginate : {
                itemsPerPage: tableSize2,
                currentPage: page2,
                totalItems: count2
              }  ;let i = index">

              <p style="width: 10%;">{{list.id}}</p>
              <p style="width: 20%;">{{list.givenName}}</p>
              <p style="width: 15%;">{{list.serialNumber || '--'}}</p>
              <p style="width: 15%;">{{list.originalCost || '--'}}</p>
              <p style="width: 15%;">{{list.currentCost || '--'}}</p>
              <p style="width: 15%;">{{list.objectCondition || '--'}}</p>
              <p class="action-buttons" style="width: 10%;padding-left: 25px;">
                <i data-toggle="modal" title="View" (click)="getObjectInfoById(list,i)" data-target="#viewModal" class="bi bi-eye-fill"></i>
                <!-- <i title="Remove" (click)="change(list)" class="bi bi-trash" data-toggle="modal" data-target="#deleteModal"></i> -->
              </p>
            </div>
          </div>


          <div class="loader" *ngIf="isLoading">
            <div class="spinner"></div>
          </div>

          <div class="loader" *ngIf="!isLoading && objectInfoList2.length == 0">
            <div class="no-data">
              <img src="assets/no-data-6.png" alt="">
              <p>no data found</p>
            </div>
          </div>

          <div class="paginator">
            <p-paginator (onPageChange)="onTableDataChange2($event)" [first]="first2" [rows]="tableSize2" [totalRecords]="count2"
              [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}">
            </p-paginator>
          </div>
        </div>

       <div class="col-lg-12 col-md-12 table-data"  *ngIf="isFailedObject">
        <div class="duplicated">
            <h5>Failed </h5>
        </div>
          <table class="table table-striped">
            <thead>
              <tr>
                <th style="width: 10%;">Id</th>
                <th style="width: 20%;">Name</th>
                <th style="width: 15%;">Serial No</th>
                <th style="width: 15%;">Original Cost</th>
                <th style="width: 15%;">Current Cost</th>
                <th style="width: 15%;">Condition</th>
                <th style="width: 10%;text-align: center;padding: 0;" class="">Action</th>
              </tr>
            </thead>
          </table>
          <div *ngIf="!isLoading">
            <div class="data-view" id="{{list.id}}" *ngFor="let list of failedObjectInfoList | paginate : {
                itemsPerPage: tableSize3,
                currentPage: page3,
                totalItems: count3
              }  ;let i = index">

              <p style="width: 10%;">{{list.id}}</p>
              <p style="width: 20%;">{{list.givenName}}</p>
              <p style="width: 15%;">{{list.serialNumber || '--'}}</p>
              <p style="width: 15%;">{{list.originalCost || '--'}}</p>
              <p style="width: 15%;">{{list.currentCost || '--'}}</p>
              <p style="width: 15%;">{{list.objectCondition || '--'}}</p>
              <p class="action-buttons" style="width: 10%;padding-left: 25px;">
                <i data-toggle="modal" title="View" (click)="getObjectInfoById(list,i)" data-target="#viewModal" class="bi bi-eye-fill"></i>
                <!-- <i title="Remove" (click)="change(list)" class="bi bi-trash" data-toggle="modal" data-target="#deleteModal"></i> -->
              </p>
            </div>
          </div>


          <div class="loader" *ngIf="isLoading">
            <div class="spinner"></div>
          </div>

          <div class="loader" *ngIf="!isLoading && failedObjectInfoList.length == 0">
            <div class="no-data">
              <img src="assets/no-data-6.png" alt="">
              <p>no data found</p>
            </div>
          </div>

          <div class="paginator">
            <p-paginator (onPageChange)="onTableDataChange3($event)" [first]="first3" [rows]="tableSize3" [totalRecords]="count3"
              [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}">
            </p-paginator>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="viewModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Asset Details
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div class="service-data" *ngFor="let viewData of singleObjectInfoData">
          <div class="form-group">
            <div class="row">
              <div class="col-md-6 col-lg-6">
                <label>Asset Id :</label>
                <p>{{viewData.objectInfoId || '--'}}</p>
              </div>
              <div class="col-md-6 col-lg-6">
                <label>Asset :</label>
                <p>{{viewData.name || '--'}}</p>
              </div>
              <div class="col-md-6 col-lg-6">
                <label>Name :</label>
                <p>{{viewData.givenName || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6" *ngIf="viewData.serialNumberCheckBox">
                <label>Serial Number :</label>
                <p>{{viewData.serialNumber || '--'}}</p>
              </div>
              <div class="col-md-6 col-lg-6">
                <label>Group :</label>
                <p>{{viewData.group || '--'}}</p>
              </div>
              <div class="col-md-6 col-lg-6">
                <label>Type :</label>
                <p>{{viewData.type || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6" *ngIf="viewData.modelCheckBox">
                <label>Model :</label>
                <p>{{viewData.model || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6" *ngIf="viewData.makeCheckBox">
                <label>Make :</label>
                <p>{{viewData.make || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>Asset Condition :</label>
                <p>{{viewData.objectCondition || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6" *ngIf="viewData.originalCostCheckBox">
                <label>Original Cost :</label>
                <p>{{viewData.originalCost || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6" *ngIf="viewData.currentCostCheckBox">
                <label>Current Cost :</label>
                <p>{{viewData.currentCost || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6" *ngIf="viewData.branchCheckBox">
                <label>Branch :</label>
                <p>{{viewData.branch || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6" *ngIf="viewData.departmentCheckBox">
                <label>Department :</label>
                <p>{{viewData.department || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6" *ngIf="viewData.locationCheckBox">
                <label>Location :</label>
                <p>{{viewData.location || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>Created Date :</label>
                <p>{{viewData.createdDate | date}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>Acquisition Date :</label>
                <p>{{viewData.acquisitionDate || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6" *ngIf="viewData.depreciationCheckbox">
                <label>Salvage Value :</label>
                <p>{{viewData.salvageValue || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6" *ngIf="viewData.depreciationCheckbox">
                <label>Depreciation Method :</label>
                <p>{{viewData.depreciationMethod || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>Estimated Asset Life (years) :</label>
                <p>{{viewData.assetLifeNumber || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>Asset Category :</label>
                <p>{{viewData.asset_Category || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6" *ngIf="viewData.error && viewData.error != ''">
                <label>Error :</label>
                <p>{{viewData.error || '--'}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>